var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFiremapAssetIndigenousSiteFieldObs = function SvgFiremapAssetIndigenousSiteFieldObs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#firemap-asset-indigenous-site-field-obs_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E131C2",
    fillRule: "evenodd",
    d: "M2 2h20v20H2zM0 24V0h24v24zm10.71-13.868c0-1.62 1.38-2.652 3.48-2.652 1.283 0 2.603.384 3.515.972l-.924 1.92c-.864-.492-2.088-.936-2.796-.936-.42 0-.696.144-.696.456 0 .481.667.664 1.48.888 1.276.35 2.912.799 2.912 2.652 0 1.788-1.584 2.64-3.468 2.64-1.428 0-2.988-.504-4.044-1.332l.936-1.896c.864.732 2.268 1.284 3.132 1.284.528 0 .864-.18.864-.564 0-.504-.688-.682-1.52-.897-1.268-.329-2.872-.744-2.872-2.535M9.314 7.588V16H6.82V7.588z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "firemap-asset-indigenous-site-field-obs_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgFiremapAssetIndigenousSiteFieldObs;